export default __webpack_public_path__ + "static/media/pl_nurse.45a0af68.png";